import { config } from '#config';
import { initPosthog } from '#src/analytics/posthog/init_posthog.ts';
import { PosthogProvider } from '#src/analytics/posthog/posthog_provider.tsx';
import { App } from '#src/app.tsx';
import { createQueryClient } from '#src/fetching/react/query_client.ts';
import { createServiceContainer } from '#src/services/create_service_container.ts';
import { resolveServiceMode } from '#src/services/service_mode.ts';
import { initSentry } from '#src/telemetry/sentry/sentry_init.ts';
import { invariant } from '@packages/primitives/invariant';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '#src/web.css';

void (async () => {
  const serviceMode = resolveServiceMode(import.meta.env.VITE_SERVICE_MODE);

  initSentry({
    ...config.sentry,
    release: import.meta.env.VITE_SENTRY_RELEASE,
  });
  initPosthog(config.posthog);

  const queryClient = createQueryClient();
  const services = await createServiceContainer(serviceMode);
  const rootElement = document.getElementById('root');
  invariant(rootElement, 'Root element not found.');

  createRoot(rootElement).render(
    <StrictMode>
      <PosthogProvider>
        <App services={services} queryClient={queryClient} />
      </PosthogProvider>
    </StrictMode>,
  );
})();
